var customQty = document.querySelectorAll('.customQty');
if (customQty) {
  customQty.forEach(function(el) {
    let input = el.querySelector('.customQtyInput');
    let plus = el.querySelector('.plus');
    let minus = el.querySelector('.minus');
    var val = Number(input.value);
    console.log(val);

    plus.addEventListener('click', function(e) {
      val++;
      input.value = val;
    });
    minus.addEventListener('click', function(e) {
      if (val > 1) {
        val--;
        input.value = val;
      }
    });
  })
}

function initAccordion(parentEl) {
  let accordionTriggers = parentEl.querySelectorAll('.accordionTrigger');
  let accordionItems = parentEl.querySelectorAll('.accordionItem');
  if (accordionTriggers.length) {
    accordionTriggers.forEach((acc) => {
      let accItem = acc.closest('.accordionItem');
      let accItems = Array.from(accordionItems).filter(el => el !== accItem);
      acc.addEventListener('click', (e) => {
        e.preventDefault();
        accItem.classList.toggle('accordion--active');
        accItems.forEach(function(item) {
          item.classList.remove('accordion--active');
        })
      })
    });
  }
}

const accordionWrap = document.querySelectorAll('.contentAccordion');
accordionWrap && accordionWrap.forEach(function(el) {
  initAccordion(el);
});

(function() {
  if (window.customElements && window.customElements.get('model-media')) {
    return;
  }

  const MODEL_VIEWER_UI_STYLES_ID = 'shopify-model-viewer-ui-styles';
  const MODEL_VIEWER_UI_STYLES_SRC = 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css';
  const loadedProducts = {};

  function loadModelViewerUiStyles() {
    if (document.getElementById(MODEL_VIEWER_UI_STYLES_ID)) {
      return;
    }

    const link = document.createElement('link');
    link.id = MODEL_VIEWER_UI_STYLES_ID;
    link.rel = 'stylesheet';
    link.href = MODEL_VIEWER_UI_STYLES_SRC;
    document.head.appendChild(link);
  }

  function getRootUrlWithoutSlash() {
    if (window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string') {
      return window.Shopify.routes.root === '/' ? '' : window.Shopify.routes.root.replace(/\/$/, '');
    }

    return '';
  }

  function loadProduct(productHandle) {
    if (!productHandle) {
      return Promise.resolve(null);
    }

    if (!loadedProducts[productHandle]) {
      loadedProducts[productHandle] = fetch(getRootUrlWithoutSlash() + '/products/' + productHandle + '.js')
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Failed to load product JSON for model media.');
          }

          return response.json();
        });
    }

    return loadedProducts[productHandle];
  }

  class ModelMedia extends HTMLElement {
    constructor() {
      super();
      this.modelUi = null;
      this.handleTogglePlay = null;
      this.handleTogglePause = null;

      loadModelViewerUiStyles();

      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
        return;
      }

      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: this.setupShopifyXr.bind(this)
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUi.bind(this)
        }
      ]);
    }

    disconnectedCallback() {
      const modelViewer = this.querySelector('model-viewer');

      if (modelViewer && this.handleTogglePlay) {
        modelViewer.removeEventListener('shopify_model_viewer_ui_toggle_play', this.handleTogglePlay);
      }

      if (modelViewer && this.handleTogglePause) {
        modelViewer.removeEventListener('shopify_model_viewer_ui_toggle_pause', this.handleTogglePause);
      }

      if (this.modelUi) {
        this.modelUi.destroy();
        this.modelUi = null;
      }
    }

    play() {
      if (this.modelUi) {
        this.modelUi.play();
      }
    }

    pause() {
      if (this.modelUi) {
        this.modelUi.pause();
      }
    }

    setupModelViewerUi() {
      if (!window.Shopify || !window.Shopify.ModelViewerUI || !this.firstElementChild) {
        return;
      }

      this.modelUi = new window.Shopify.ModelViewerUI(this.firstElementChild, { focusOnPlay: false });

      const modelViewer = this.querySelector('model-viewer');
      if (!modelViewer) {
        return;
      }

      this.handleTogglePlay = function() {
        modelViewer.dispatchEvent(new CustomEvent('model:played', { bubbles: true }));
      };

      this.handleTogglePause = function() {
        modelViewer.dispatchEvent(new CustomEvent('model:paused', { bubbles: true }));
      };

      modelViewer.addEventListener('shopify_model_viewer_ui_toggle_play', this.handleTogglePlay);
      modelViewer.addEventListener('shopify_model_viewer_ui_toggle_pause', this.handleTogglePause);
    }

    async setupShopifyXr() {
      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', this.setupShopifyXr.bind(this), { once: true });
        return;
      }

      const product = await loadProduct(this.getAttribute('product-handle'));
      if (!product || !Array.isArray(product.media)) {
        return;
      }

      const models = product.media.filter(function(media) {
        return media.media_type === 'model';
      });

      if (!models.length) {
        return;
      }

      window.ShopifyXR.addModels(models);
      window.ShopifyXR.setupXRElements();
    }
  }

  window.customElements.define('model-media', ModelMedia);
})();

document.addEventListener('DOMContentLoaded', function() {
  const homeHeroSlider = document.querySelector('.home-hero-slider .slideshow');
  if (homeHeroSlider) {
    setTimeout(function() {
      window.dispatchEvent(new Event('resize'));
    }, 500);
  }
});